import { AutomatedConfigTypeEnum } from './automated-config-type-enum';

export class AutomatedOfferCreateConfiguration {
  type: AutomatedConfigTypeEnum;
  aircraftId: number;
  models: Array<string>;
  categoryId: number;
}
